module.exports = __webpack_public_path__ + "img/safety-summary-icon2.6fb6f47e.svg";